import { RouterLinkOptimised } from '@/components/RouterLinkOptimised';
import { cn } from '@simplywallst/ui-core/next';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  isSelected: boolean;
  href: string;
  isDisabled?: boolean;
};

export const NarrativeTab = ({
  children,
  isSelected,
  isDisabled,
  href,
}: Props) => {
  return (
    <RouterLinkOptimised
      role="tab"
      to={href}
      onClick={(e) => {
        if (!isDisabled) return;

        e.preventDefault();
        e.stopPropagation();
      }}
      onKeyDown={(e) => {
        if (!isDisabled) return;
        if (e.key !== 'Enter') return;

        e.preventDefault();
        e.stopPropagation();
      }}
      aria-selected={isSelected}
      aria-disabled={!!isDisabled}
      className={cn(
        'focus-outline relative grid h-x6 w-full items-center justify-center border-none px-x2 pb-x0_5 text-xs text-soft no-underline',
        isSelected &&
          'text-solid shadow-[inset_0_-4px_0_0_var(--s-color-accent)]',
        isDisabled && 'pointer-events-none cursor-not-allowed'
      )}
    >
      {children}
    </RouterLinkOptimised>
  );
};
